import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { Observable } from 'rxjs';

export interface MapboxGeocodeResult {
    attribution: string;
    features: MapboxGeocodeFeature[];
    query: number[];
    type: string;
}

export interface MapboxGeocodeFeature {
    address: string;
    center: number[];
    context: GeocodeContext[];
    geometry: {
        coordinates: number[];
        type: string;
    };
    id: string;
    place_name: string;
    place_type: string[];
    properties: {
        accuracy: string;
        mapbox_id: string;
    };
    relevance: number;
    text: string;
    type: string;
}

export interface GeocodeContext {
    id: string;
    mapbox_id?: string;
    short_code?: string;
    text?: string;
    wikidata?: string;
}

@Injectable({ providedIn: 'root' })
export class GeocoderResource {
    private baseUrl =
        'https://api.mapbox.com/geocoding/v5/mapbox.places-permanent/';

    constructor(
        private configService: ConfigService,
        private http: HttpClient
    ) {}

    getLngLatByPlaceName(
        placeName: string,
        proximity?: number[]
    ): Observable<MapboxGeocodeResult> {
        // Optional params
        // country - ISO 3166 alpha 2 country codes, separated by commas
        // proximity - Location around which to bias results, given as [lng, lat]
        // types - Filter results by one or more type. Options are: country, region, postcode, place, locality,
        //         neighborhood, address, poi. Multiple options can be comma-separated.
        // autocomplete - Whether or not to return autocomplete results. Options are: true and false. Defaults to true.
        // bbox - Bounding box within which to limit results, given as [minLng, minLat, maxLng, maxLat].
        let params = new HttpParams();
        if (proximity) {
            params = params.set('proximity', String(proximity));
        }
        const url = `${this.baseUrl}${placeName}.json?access_token=${this.configService.mapboxToken}`;
        return this.http.get<MapboxGeocodeResult>(url, { params });
    }

    getPlaceNamesByLngLat(
        lng: number,
        lat: number
    ): Observable<MapboxGeocodeResult> {
        const url = `${this.baseUrl}${lng},${lat}.json?access_token=${this.configService.mapboxToken}`;

        return this.http.get<MapboxGeocodeResult>(url);
    }

    getAddressByLngLat(
        lng: number,
        lat: number
    ): Observable<MapboxGeocodeResult> {
        const url = `${this.baseUrl}${lng},${lat}.json?types=address&access_token=${this.configService.mapboxToken}`;

        return this.http.get<MapboxGeocodeResult>(url);
    }
}
